
import React, { Component } from 'react';
import { Modal, Form, Input, Select } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

const fields = [{
    "text": "提交人",
    "field": "name",
    "label": true
}, {
    "text": "提交时间",
    "field": "insertTime",
    "label": true
}, {
    "text": "反馈建议",
    "field": "content",
    "label": true
}, {
    "text": "处理状态",
    "field": "status",
    "select": true
}, {
    "text": "回复信息",
    "field": "reply",
    "textarea": 'true',
    rules: [
        { max: 256, message: '回复信息不能超过256个字符！' },
    ]
}];


class FeedbackEditForm extends Component {

    state = {}

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            delete values["insertTime"];
            http.post({
                url: '/feedback/handleFeedback',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field] == null ? "" : "" + editData[item.field]
                        })(
                            item.select ?
                                <Select >
                                    <Select.Option key="0">未处理</Select.Option>
                                    <Select.Option key="1">已知晓</Select.Option>
                                    <Select.Option key="2">已处理</Select.Option>
                                </Select>
                                : item.label ? <span>{editData[item.field]}</span>
                                    : item.textarea ? <Input.TextArea rows={4} />
                                        : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="车位信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const FeedbackEdit = Form.create()(FeedbackEditForm);

export default FeedbackEdit;